import { clsx } from '../../../ds/clsx';
import styles from './ui.module.css';

export interface TicketAvatarProps {
  initials: string;
  /** Full name for assistive technology; omit when the name is printed next to the avatar. */
  name?: string | undefined;
  /** 20 (table, select), 22 (board card), 32 (thread, contact card). */
  size: 20 | 22 | 32;
  /** `dark` = staff (`--navy-900`), `light` = customer or escalation target (`--sand-200`), A2 „Avatar-Kreis". */
  tone: 'dark' | 'light';
  className?: string | undefined;
}

/** The small initials circle of the ticket screens; the DS avatar starts at 26 px. */
export function TicketAvatar({ initials, name, size, tone, className }: TicketAvatarProps) {
  return (
    <span
      className={clsx(
        styles.avatar,
        tone === 'dark' ? styles.avatarDark : styles.avatarLight,
        size === 20 ? styles.avatar20 : size === 22 ? styles.avatar22 : styles.avatar32,
        className,
      )}
      role={name ? 'img' : undefined}
      aria-label={name}
      aria-hidden={name ? undefined : true}
    >
      {initials}
    </span>
  );
}
